import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Cropper from 'react-easy-crop';
import Modal from '../Modal';
import * as Style from './style';
import Button from '../Button';
import color from '../../../config/colors.json';

const ImageCropModal = ({
    submitCrop, isOpen, openAction, image, setLogoName,
}) => {
    const [secondLogo, setSecondLogo] = useState(false);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [cropSize, setCropsize] = useState(() => (
        { width: 300, height: 300 }
    ));
    const [img, setImg] = useState('');
    const [cropData, setCropData] = useState({
        width: 600,
        height: 150,
        crop_width: 400,
        crop_height: 600,
        crop_x: 0,
        crop_y: 0,
    });
    const onCropComplete = useCallback((croppedArea, croppedPixels) => {
        setCropData(oldData => ({
            ...oldData,
            width: 600,
            height: (secondLogo ? 150 : 600),
            crop_width: Math.round(croppedPixels.width),
            crop_height: Math.round(croppedPixels.height),
            crop_x: Math.round(croppedPixels.x),
            crop_y: Math.round(croppedPixels.y),
        }));
    }, []);

    useEffect(() => {
        setImg(image);
    }, [image]);

    useEffect(() => {
        if (isOpen === false) {
            setSecondLogo(false);
            setZoom(1);
        }
    }, [isOpen]);

    const closeModal = () => {
		setSecondLogo(false);
		setCropsize({ width: 300, height: 300 });
		setLogoName('');
        openAction(false);
	};

    const submitCroppedLogo = () => {
		if (!secondLogo) {
			setCropsize({ width: 300, height: 75 });
			setSecondLogo(true);
			return submitCrop(cropData);
		}

		submitCrop({
			...cropData,
			height: 150,
		});

		return closeModal();
    };


    return (
	<Modal isOpen={isOpen} openAction={openAction}>
		<Style.Container>
			<div className="row" style={{ boxShadow: '0px 0px 17px -4px rgba(0,0,0,0.64)' }}>
				<div className="col-12">
					<div
						className="d-flex justify-content-center"
						style={{ padding: '25px 0', marginTop: '-1px', backgroundColor: color.lightGrey4 }}
					>
						<Style.Title>Enquadre a logo corretamente:</Style.Title>
					</div>
				</div>
				<div className="col-12">
					<div className="d-flex justify-content-center" style={{ height: '50vh' }}>
						<Cropper
							image={img}
							crop={crop}
							zoom={zoom}
							cropSize={cropSize}
							onCropChange={setCrop}
							onCropComplete={onCropComplete}
							onZoomChange={setZoom}
							restrictPosition={false}
							minZoom={0.1}
							maxZoom={2}
							zoomSpeed={0.1}
							showGrid={false}
							style={{
                                    containerStyle: {
                                        backgroundColor: '#fff',
                                    },
                                    cropAreaStyle: {
                                        border: '1px dashed #000',
                                        boxShadow: '0 0 1000px 1000px rgba(230,230,230,.5)',
                                    },
                                }}
						/>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<div className="d-flex flex-row justify-content-around" style={{ padding: '24px 0', flexWrap: 'wrap' }}>
						<div className="d-flex align-items-center">
							<Style.Label>
								1º Formato: <br />
								600 x 600 (obrigatório)
							</Style.Label>
						</div>
						<div className="d-flex align-items-center">
							<Style.Label>
								2º Formato: <br />
								600 x 150 (opcional)
							</Style.Label>
						</div>
						<div className="d-flex flex-column" style={{ width: '373px' }}>
							<Style.Label htmlFor="zoom">
								zoom da imagem
							</Style.Label>
							<Style.Range min=".1" max="2" step=".1" value={zoom} onChange={e => setZoom(e.target.value)} type="range" name="zoom" id="zoom" />
							<div className="d-flex flex-row justify-content-between" style={{ width: '100%' }}>
								<span>Min</span>
								<span>Max</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<hr style={{ display: 'block', margin: '0 0 21px' }} />
			<div className="row">
				<div className="col">
					<div className="d-flex justify-content-between" style={{ padding: '0 20px 22px' }}>
						<div>
							<Button onClick={closeModal} fit theme="light2" bordered fontSize="14px" lineheight="20px" padding="8px 23px">Alterar logo</Button>
						</div>
						<div className="d-flex flex-row">
							{secondLogo && (<Button onClick={closeModal} className="mr-4" fit theme="light2" bordered fontSize="14px" lineheight="20px" padding="8px 23px">Ignorar 2&ordm; formato</Button>)}
							<Button fit fontSize="14px" lineheight="20px" padding="8px 23px" onClick={submitCroppedLogo}>Cadastrar logo</Button>
						</div>
					</div>
				</div>
			</div>
		</Style.Container>
	</Modal>
    );
};

PropTypes.ImageCropModal = {
	submitCrop: PropTypes.func.isRequired,
	isOpen: PropTypes.bool.isRequired,
	openAction: PropTypes.func.isRequired,
	image: PropTypes.string.isRequired,
	setLogoName: PropTypes.func.isRequired,
};

export default ImageCropModal;
